/* eslint-disable no-script-url,jsx-a11y/anchor-is-valid */
import React from "react";

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'

export function HeaderMenu({ layoutProps }) {

    return <div
        id="kt_header_menu"
        className={`header-menu header-menu-mobile ${layoutProps.ktMenuClasses}`}
        {...layoutProps.headerMenuAttributes}
    >
        {/*begin::Header Nav*/}
        <ul className={`menu-nav ${layoutProps.ulClasses}`}>
            {/*begin::1 Level*/}
            <button className="brand-toggle btn btn-sm px-0" id="kt_aside_toggle">
                    <FontAwesomeIcon icon="bars" />

                    <span className="px-4">Main Menu</span>
                </button>
           
            
        </ul>
        {/*end::Header Nav*/}
    </div>;
}
